export class SetUserCountry {
    static readonly type = '[CommonData] Set User Country';
    constructor(public countryCode: string) { }
  }

  export class SetUserApexId {
    static readonly type = '[CommonData] Set User Apex Id';
    constructor(public apexId: string) { }
  }

  export class SetDashboardTeamMessageDetails {
    static readonly type = '[CommonData] Set Dashboard Team Message Details';
    constructor() { }
  }
